/**
 * Return whether the given detection type is supported by the marking tool
 * @param type
 * @returns
 */
export function isSupportedMarkingType(type: string) {
  return ['bed', 'chair', 'seating_group'].includes(type);
}
